"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalLastYearPriceWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../commonFunctions");
var core_1 = require("@athena-portal/core");
var moment = require("moment");
var RenewalLastYearPriceWidget = /** @class */ (function (_super) {
    __extends(RenewalLastYearPriceWidget, _super);
    function RenewalLastYearPriceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.isDataLoaded = function () {
            return _this.state.currentPolicyLoaded
                && _this.state.paymentLoaded
                && _this.state.instalmentsInfoLoaded;
        };
        _this.state = {
            currentPolicyLoaded: false,
            paymentLoaded: false,
            instalmentsInfoLoaded: false
        };
        return _this;
    }
    RenewalLastYearPriceWidget.prototype.componentDidMount = function () {
        var _this = this;
        var product = this.getProductByPolicyNumber(this.props.interaction.agreementNumber);
        this.customerPortalService.getPolicies(product, services_1.EnumPolicyFilter.NOT_ENDED, true).subscribe(function (policies) {
            var activePolicies = __spreadArray([], policies, true).sort(function (a, b) { return moment(b.endDate).diff(a.endDate); });
            var filteredPolicy = activePolicies
                .filter(function (policy) { return policy.products.includes(product) && policy.policyNumber === _this.props.interaction.agreementNumber; })[0];
            _this.setState({
                currentPolicy: filteredPolicy,
                currentPolicyLoaded: true
            });
            if (filteredPolicy) {
                _this.loadPaymentsHistoryWhenInRenewalWindow(filteredPolicy, _this.props.interaction.agreementNumber);
            }
            var agreementVersionIds = filteredPolicy.policyHistoryList
                .filter(function (ph) { return ph.status !== services_1.POLICY_STATUS_MTC; })
                .map(function (ph) { return ph.id; });
            _this.customerPortalService.getCombinedInstalmentsInfo(agreementVersionIds).subscribe(function (instalmentsInfo) {
                _this.setState({
                    instalmentsInfo: instalmentsInfo,
                    instalmentsInfoLoaded: true
                });
            });
        });
    };
    RenewalLastYearPriceWidget.prototype.renderInputField = function () {
        var _a, _b, _c;
        if (this.isDataLoaded()) {
            var monthlyPayments = this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
            var currentPolicyInteraction = (_a = this.state.currentPolicy) === null || _a === void 0 ? void 0 : _a.interaction;
            var monthlyLastYearPayment = currentPolicyInteraction.paymentDetails.instalmentPlan.monthlyPayment;
            var monthlyLastYearTotalAmount = currentPolicyInteraction.paymentDetails.instalmentPlan.totalAmount;
            var totalAmountFromExistingPayments = this.getTotalAmountFromExistingPayments();
            var monthlyTotalLastYearPriceAfterMTA = totalAmountFromExistingPayments.toFixed(2);
            var monthlyLastYearPriceAfterMTA = (totalAmountFromExistingPayments / 12).toFixed(2);
            var annualLastYearPrice = currentPolicyInteraction.factors.annualPremium;
            var monthlyLastYearPrice = ((_b = this.state.currentPolicy) === null || _b === void 0 ? void 0 : _b.interaction.process) === services_1.INTERACTION_PROCESS_MTA ? monthlyLastYearPriceAfterMTA : monthlyLastYearPayment;
            var monthlyTotalLastYearPrice = ((_c = this.state.currentPolicy) === null || _c === void 0 ? void 0 : _c.interaction.process) === services_1.INTERACTION_PROCESS_MTA ? monthlyTotalLastYearPriceAfterMTA : monthlyLastYearTotalAmount;
            return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("p", { className: "mb-0 mt-5 font-weight-bold", children: ["Last year`s price ", monthlyPayments ? (0, commonFunctions_1.getAmountToDisplay)(monthlyTotalLastYearPrice) : (0, commonFunctions_1.getAmountToDisplay)(annualLastYearPrice), "***"] }), monthlyPayments && (0, jsx_runtime_1.jsxs)("p", { className: "mb-0", children: ["You paid ", (0, commonFunctions_1.getAmountToDisplay)(monthlyLastYearPrice), "/month"] })] }));
        }
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
    };
    RenewalLastYearPriceWidget.prototype.getProductByPolicyNumber = function (policyNumber) {
        if (services_1.POLICY_NUMBER_PREFIX_MAP.HOME.some(function (prefix) { return policyNumber.startsWith(prefix); })) {
            return services_1.ProductsEnum.HOME;
        }
        if (services_1.POLICY_NUMBER_PREFIX_MAP.WOLF_MOTOR.some(function (prefix) { return policyNumber.startsWith(prefix); })) {
            return services_1.ProductsEnum.WOLF_MOTOR;
        }
        return services_1.ProductsEnum.SUBSCRIPTION;
    };
    RenewalLastYearPriceWidget.prototype.getTotalAmountFromExistingPayments = function () {
        var _a, _b;
        if (this.state.payment && this.state.instalmentsInfo) {
            var totalPayment_1 = 0;
            (_a = this.state.payment) === null || _a === void 0 ? void 0 : _a.paymentDetailsList.forEach(function (pd) { return totalPayment_1 += pd.amount; });
            if ((_b = this.state.instalmentsInfo) === null || _b === void 0 ? void 0 : _b.payOffAmountWithRemainingInterest) {
                totalPayment_1 = totalPayment_1 + this.state.instalmentsInfo.payOffAmountWithRemainingInterest;
            }
            return totalPayment_1;
        }
        else {
            return 0;
        }
    };
    RenewalLastYearPriceWidget.prototype.loadPaymentsHistoryWhenInRenewalWindow = function (filteredPolicy, policyNumber) {
        var _this = this;
        // load payments only when in renewal window, required for manual renewal modal
        var dateDiff = moment.utc(filteredPolicy.endDate, moment.ISO_8601).diff(moment(), 'days');
        var daysBeforeRenewalIssued = 32;
        if (dateDiff <= daysBeforeRenewalIssued) {
            this.customerPortalService.getPaymentHistoryCurrentPeriod(policyNumber).subscribe(function (payment) {
                var filteredPayments = payment;
                filteredPayments.paymentDetailsList = filteredPayments.paymentDetailsList.filter(function (paymentDetails) {
                    return _this.checkPaymentInCurrentPolicy(filteredPolicy, paymentDetails);
                });
                _this.setState({
                    payment: filteredPayments,
                    paymentLoaded: true
                });
            });
        }
    };
    RenewalLastYearPriceWidget.prototype.checkPaymentInCurrentPolicy = function (filteredPolicy, paymentDetails) {
        var _a;
        return !!((_a = filteredPolicy.policyHistoryList) === null || _a === void 0 ? void 0 : _a.find(function (policyHistory) { return paymentDetails.policyVersion.some(function (x) { return x.id === policyHistory.id.toString(); }); }));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], RenewalLastYearPriceWidget.prototype, "customerPortalService", void 0);
    return RenewalLastYearPriceWidget;
}(plugin_journey_1.QuestionWidgetBase));
exports.RenewalLastYearPriceWidget = RenewalLastYearPriceWidget;
//# sourceMappingURL=RenewalLastYearPriceWidget.js.map